/**
 * EventBus — pub/sub for communication between modules without direct dependencies
 */

export default class EventBus {
  constructor() {
    this._listeners = {};
  }

  /**
   * Subscribe to an event
   * @param {string} event - Event name
   * @param {Function} callback - Handler function
   */
  on(event, callback) {
    if (!this._listeners[event]) {
      this._listeners[event] = [];
    }
    this._listeners[event].push(callback);
  }

  /**
   * Unsubscribe from an event
   * @param {string} event - Event name
   * @param {Function} callback - Handler to remove
   */
  off(event, callback) {
    const list = this._listeners[event];
    if (!list) return;
    this._listeners[event] = list.filter((cb) => cb !== callback);
  }

  /**
   * Emit an event to all subscribers
   * @param {string} event - Event name
   * @param {*} [data] - Event data
   */
  emit(event, data) {
    const list = this._listeners[event];
    if (!list) return;
    for (const cb of list) {
      try {
        cb(data);
      } catch (err) {
        console.error(`[GarderoboSearch] Error in event handler for "${event}":`, err);
      }
    }
  }

  /**
   * Remove all listeners (used on destroy)
   */
  clear() {
    this._listeners = {};
  }
}
